<template>
<!-- Footer -->
    <footer>
        <div class="container">
            <p>&copy; 2026 Sumantha Chandrashekara. All rights reserved.</p>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>

</style>
